import messagesListInboxContainer from './messages_list_inbox_container';

const messagesListInbox = messagesListInboxContainer;
export default messagesListInbox;
